import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import React, { ReactNode, useMemo } from "react";
import { Label } from "reactstrap";
import {
  FACEBOOK_COLOR,
  INSTAGRAM_COLOR,
  WHATSAPP_COLOR,
} from "../../../constants/socialColors.constant";
import { Contact } from "../../../cores/socialChat/interfaces/conversations";
import { getFirstLetters } from "../../utils/stringUtils";
import Avatar from "../Avatar";
import { PanelWembii } from "../PanelWembii";

interface Props {
  color: string;
  type: string;
  contacts: Contact[];
  avatarAction?: (arg0: Contact) => void;
  actions?: ReactNode;
}

export default function PanelChatTitle(props: Props) {
  const { color, type, contacts, actions, avatarAction } = props;

  const getParticipantNames = useMemo(
    () => contacts.map((participant) => participant.name).join(", "),
    [contacts]
  );

  return (
    <PanelWembii shadow className="p-3 mb-3">
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          {type === "facebook" && (
            <FontAwesomeIcon
              className=""
              icon={["fab", "facebook"]}
              size="lg"
              color={FACEBOOK_COLOR}
            />
          )}
          {type === "instagram" && (
            <FontAwesomeIcon
              className=""
              icon={["fab", "instagram"]}
              size="lg"
              color={INSTAGRAM_COLOR}
            />
          )}
          {type === "whatsapp" && (
            <FontAwesomeIcon
              className=""
              icon={["fab", "whatsapp"]}
              size="lg"
              color={WHATSAPP_COLOR}
            />
          )}
          <Avatar
            className={cn("mx-2", {
              pointer: !!avatarAction,
            })}
            label={getFirstLetters(contacts[0].name)}
            image={contacts[0].avatarUrl}
            backgroundColor={color}
            color="#fff"
            width={"56px"}
            height={"56px"}
            onClick={() => avatarAction?.(contacts[0])}
          />
          <Label
            onClick={() => avatarAction?.(contacts[0])}
            className="text-primary font-weight-bold m-0"
            size="lg"
          >
            {getParticipantNames}
          </Label>
        </div>
        {actions && actions}
      </div>
    </PanelWembii>
  );
}
